// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorSelector_A0KYt {
  margin: 8px 0 8px 0;
}

.selectorButtons_ztilA {
  > button {
    display: inline-flex;
    color: var( --grey );
    border: 1px solid var( --lighter-grey );
  }
  > button:hover {
    background-color: var( --lighter-grey );
  }
  .selector_NWe2o {
    background-color: white;
    border-radius: 0;
  }
  > :first-child {
    border-top-left-radius: 25%;
    border-bottom-left-radius: 25%;
  }
  > :last-child {
    border-top-right-radius: 25%;
    border-bottom-right-radius: 25%;
  }
  .primary_qcg0q {
    background-color : var( --green );
    border-color: var( --green );
    color: white;
  }
  .primary_qcg0q:hover, .primary_qcg0q:focus, .primary_qcg0q:active {
    background-color: var( --green );
  }
}

.row_Dw3kg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.historyItemArea_xHuBs {
  align-items: flex-start
}

.endContainer_XSWNN {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.search_qRiFA {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.header_uKsF9 {
  display: flex;
}
.flexRight_rRSjy {
  margin-left: auto;
}
.perPageDropdown_LZxpo{
  min-width: 75px;
}
.left_DadUb {
  height: 100%;
}
.pagination_CHncM {
  margin : auto 0 0 0;
}
.header_uKsF9 {
  padding : 10px 26px 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom:5px solid var( --background );/*var( --border-color );*/
}

.list_NDMIW {
  height: 100%;
  width: 100%;
  border:1px solid var( --lighter-grey );
  flex: 1;
}

.content_ThCPq {
  height: 100%;
  padding: 10px 26px 10px 20px;
  .queryEditor_b0ZnW {
    border : 1px solid var( --lighter-grey );
  }
  .cFlex_LyPZn {
    height: 100%;
    .selectors_vMZKg {
      display: flex;
      flex-direction: row;
      width : 100%;
      button {
        font-size: 12px;
        padding: 4px 8px;
      }
      .resultSelector_wKXmQ {
        margin-left: 16px;
        margin-right: auto;
      }
    }
  }
}

.optionsMenu_OJ8QH {
  margin-left: auto;
  font-size: 16px;
  background-color: rgba( 0, 0, 0, 0 );
}
.optionsMenu_OJ8QH.popupOpen_dwLVe {
  background-color: var( --light-grey );
  .option_hcg54 {
    background-color: white;
    color: black;
  }
  .option_hcg54:hover {
    text-decoration: none;
    background-color: var( --lighter-grey );
  }
}
.optionsMenu_OJ8QH.popupOpen_dwLVe:hover {
  background-color: var( --light-grey );
}

.left_DadUb {
  margin-right: auto;
}

.right_Ajztq {
  margin-left: auto;
  align-items: flex-start;
  .jump_pAzkG {
    text-decoration: underline;
    cursor: pointer;
  }
  .jump_pAzkG:hover {
    color : var( --purple );
  }
}

.icon_Fss_E {
  background-color: var( --purple );
  color: white;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 5px;
  margin-left: 0;
  .textTop_x_Fq6 {
    vertical-align: text-top;
  }
}

.splitRight_OK5Gd {
  width: 450px;
  height: 100%;
  background : var( --background );
}
.stopTimer_RMDU8 i {
  color: var( --red );
}
.deleteTimer_XoNU_ i {
  color: var( --grey )
}
.editor_Fr4ZI {
  height: 100%;
}

.filter_P0bQu {
  display : flex;
  flex-direction: row;
  width: 100%;
}

.center_onO58 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  .loadMore_tZ9M6 {
    color: var( --purple );
    margin-right: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/history/style.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,iCAAiC;IACjC,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C,CAAC,yBAAyB;AACvE;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B;IACE,wCAAwC;EAC1C;EACA;IACE,YAAY;IACZ;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ;QACE,eAAe;QACf,gBAAgB;MAClB;MACA;QACE,iBAAiB;QACjB,kBAAkB;MACpB;IACF;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,qCAAqC;EACrC;IACE,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,uCAAuC;EACzC;AACF;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB;IACE,0BAA0B;IAC1B,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":["@import \"../../style/theme.css\";\n\n.editorSelector {\n  margin: 8px 0 8px 0;\n}\n\n.selectorButtons {\n  > button {\n    display: inline-flex;\n    color: var( --grey );\n    border: 1px solid var( --lighter-grey );\n  }\n  > button:hover {\n    background-color: var( --lighter-grey );\n  }\n  .selector {\n    background-color: white;\n    border-radius: 0;\n  }\n  > :first-child {\n    border-top-left-radius: 25%;\n    border-bottom-left-radius: 25%;\n  }\n  > :last-child {\n    border-top-right-radius: 25%;\n    border-bottom-right-radius: 25%;\n  }\n  .primary {\n    background-color : var( --green );\n    border-color: var( --green );\n    color: white;\n  }\n  .primary:hover, .primary:focus, .primary:active {\n    background-color: var( --green );\n  }\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.historyItemArea {\n  align-items: flex-start\n}\n\n.endContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.search {\n  width: 80%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.header {\n  display: flex;\n}\n.flexRight {\n  margin-left: auto;\n}\n.perPageDropdown{\n  min-width: 75px;\n}\n.left {\n  height: 100%;\n}\n.pagination {\n  margin : auto 0 0 0;\n}\n.header {\n  padding : 10px 26px 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom:5px solid var( --background );/*var( --border-color );*/\n}\n\n.list {\n  height: 100%;\n  width: 100%;\n  border:1px solid var( --lighter-grey );\n  flex: 1;\n}\n\n.content {\n  height: 100%;\n  padding: 10px 26px 10px 20px;\n  .queryEditor {\n    border : 1px solid var( --lighter-grey );\n  }\n  .cFlex {\n    height: 100%;\n    .selectors {\n      display: flex;\n      flex-direction: row;\n      width : 100%;\n      button {\n        font-size: 12px;\n        padding: 4px 8px;\n      }\n      .resultSelector {\n        margin-left: 16px;\n        margin-right: auto;\n      }\n    }\n  }\n}\n\n.optionsMenu {\n  margin-left: auto;\n  font-size: 16px;\n  background-color: rgba( 0, 0, 0, 0 );\n}\n.optionsMenu.popupOpen {\n  background-color: var( --light-grey );\n  .option {\n    background-color: white;\n    color: black;\n  }\n  .option:hover {\n    text-decoration: none;\n    background-color: var( --lighter-grey );\n  }\n}\n.optionsMenu.popupOpen:hover {\n  background-color: var( --light-grey );\n}\n\n.left {\n  margin-right: auto;\n}\n\n.right {\n  margin-left: auto;\n  align-items: flex-start;\n  .jump {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  .jump:hover {\n    color : var( --purple );\n  }\n}\n\n.icon {\n  background-color: var( --purple );\n  color: white;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 5px;\n  margin-left: 0;\n  .textTop {\n    vertical-align: text-top;\n  }\n}\n\n.splitRight {\n  width: 450px;\n  height: 100%;\n  background : var( --background );\n}\n.stopTimer i {\n  color: var( --red );\n}\n.deleteTimer i {\n  color: var( --grey )\n}\n.editor {\n  height: 100%;\n}\n\n.filter {\n  display : flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  .loadMore {\n    color: var( --purple );\n    margin-right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorSelector": `editorSelector_A0KYt`,
	"selectorButtons": `selectorButtons_ztilA`,
	"selector": `selector_NWe2o`,
	"primary": `primary_qcg0q`,
	"row": `row_Dw3kg`,
	"historyItemArea": `historyItemArea_xHuBs`,
	"endContainer": `endContainer_XSWNN`,
	"search": `search_qRiFA`,
	"header": `header_uKsF9`,
	"flexRight": `flexRight_rRSjy`,
	"perPageDropdown": `perPageDropdown_LZxpo`,
	"left": `left_DadUb`,
	"pagination": `pagination_CHncM`,
	"list": `list_NDMIW`,
	"content": `content_ThCPq`,
	"queryEditor": `queryEditor_b0ZnW`,
	"cFlex": `cFlex_LyPZn`,
	"selectors": `selectors_vMZKg`,
	"resultSelector": `resultSelector_wKXmQ`,
	"optionsMenu": `optionsMenu_OJ8QH`,
	"popupOpen": `popupOpen_dwLVe`,
	"option": `option_hcg54`,
	"right": `right_Ajztq`,
	"jump": `jump_pAzkG`,
	"icon": `icon_Fss_E`,
	"textTop": `textTop_x_Fq6`,
	"splitRight": `splitRight_OK5Gd`,
	"stopTimer": `stopTimer_RMDU8`,
	"deleteTimer": `deleteTimer_XoNU_`,
	"editor": `editor_Fr4ZI`,
	"filter": `filter_P0bQu`,
	"center": `center_onO58`,
	"loadMore": `loadMore_tZ9M6`
};
export default ___CSS_LOADER_EXPORT___;
